import { useEffect, useState } from "react";
import { Youtube } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import { VideoCard } from "@/components/sections/VideoCard";
import { IMAGES } from "@/lib/content";
import { api } from "@/lib/api";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {}).finally(() => setLoading(false));
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const subscribeUrl = settings.youtube_subscribe_url || settings.youtube_channel_url || "";

  return (
    <>
      <PageHeader label="Videos" title="THE VIDEO LIBRARY" image={IMAGES.hero}>
        Every episode of the journey in one place — the builds, the breeding, the wins and the failures.
      </PageHeader>

      <section className="pb-28" data-testid="videos-page">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-center justify-end mb-8">
            <a
              href={subscribeUrl || "#"}
              onClick={(e) => !subscribeUrl && e.preventDefault()}
              target={subscribeUrl ? "_blank" : undefined}
              rel="noreferrer"
              data-testid="videos-subscribe-btn"
              className="btn-primary px-6 py-3 text-sm inline-flex items-center gap-2"
            >
              <Youtube size={18} /> Subscribe on YouTube
            </a>
          </div>

          {loading ? (
            <p className="text-brand-textMuted">Loading…</p>
          ) : videos.length === 0 ? (
            <div className="card-surface p-12 text-center">
              <Youtube size={30} className="mx-auto text-brand-textMuted" />
              <p className="text-brand-textSec mt-4">No videos yet — the first episodes are on the way.</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {videos.map((v, i) => (
                <Reveal key={v.id} delay={(i % 3) * 0.08}>
                  <VideoCard video={v} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
